export default __webpack_public_path__ + "static/media/icon.d61bda46.png";